import { useEffect, useRef, useState } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import Home from "./Pages/Home/Home";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import Login from "./Pages/Login/Login";
import Status from "./Pages/Status/Status";
import ProtectedRoute from "./Auth/protectedRoute";
import A11y from "./Components/A11y/A11y";
import PDFViewer from "./Pages/PDFViewer/PDFViewer";
import "@geti/identidade-visual-react/identidade-visual.css";
import "./responsive-patch.css";

function App() {
  const cursorRef = useRef<HTMLDivElement | null>(null);
  const colorInverted = useSelector(
    (state: any) => state.a11ySlice.colorInverted
  );
  const [fontSize, setFontSize] = useState(1);
  const [grayscale, setGrayscale] = useState(false);
  const [customCursor, setCustomCursor] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isOpenModal, setIsOpenModal] = useState(true);

  useEffect(() => {
    const html = document.documentElement;

    html.classList.toggle("invert-colors", colorInverted);
    html.classList.toggle("grayscale", grayscale);
    html.style.fontSize = `${fontSize * 100}%`;
    html.style.setProperty("--font-size", `${fontSize}rem`);
    html.style.setProperty(
      "--cursor-pointer",
      customCursor ? "none" : "pointer"
    );
    html.style.setProperty(
      "--cursor-not-allowed",
      customCursor ? "none" : "not-allowed"
    );
    html.style.setProperty(
      "--cursor-default",
      customCursor ? "none" : "default"
    );
    html.style.setProperty("--cursor-text", customCursor ? "none" : "text");
    html.style.cursor = customCursor ? "none" : "";
  }, [colorInverted, grayscale, fontSize, customCursor]);

  const handleMouseMove = (e: React.MouseEvent) => {
    setMousePosition({ x: e.clientX, y: e.clientY });
  };

  const handleMouseEnter = () => {
    if (cursorRef.current) {
      cursorRef.current.style.display = "block";
    }
  };

  const handleMouseLeave = () => {
    if (cursorRef.current) {
      cursorRef.current.style.display = "none";
    }
  };

  return (
    <div
      className="App"
      onMouseEnter={customCursor ? handleMouseEnter : undefined}
      onMouseLeave={customCursor ? handleMouseLeave : undefined}
      onMouseMove={customCursor ? handleMouseMove : undefined}
    >
      <div
        ref={cursorRef}
        className={customCursor ? "cursor" : ""}
        style={{
          top: customCursor ? `${mousePosition.y}px` : "auto",
          left: customCursor ? `${mousePosition.x}px` : "auto",
        }}
      />
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pdf-viewer/:fileKey" element={<PDFViewer />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/status"
              element={<ProtectedRoute Component={Status} path="/status" />}
            />
          </Routes>
        </main>
        <A11y
          setFontSize={setFontSize}
          setGrayscale={setGrayscale}
          setCustomCursor={setCustomCursor}
          isOpenModal={isOpenModal}
          setIsOpenModal={setIsOpenModal}
        />
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
